import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL, PARSE_APPLICATION_ID, PARSE_REST_API_KEY } from "../api";
import Parse from "parse";

export const validateReceipt = createAsyncThunk(
  "receipts/validateReceipt",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/functions/validate-receipt";
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          url: payload.url,
        }),
      };

      const res = await fetch(url, options);
      const data = await res.json();

      if (res.error) {
        rejectWithValue(res.error);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const manualReceiptAdd = createAsyncThunk(
  "receipts/manualReceiptAdd",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/functions/manual-receipt-add";
      const user = getState().user.userMe;
      const options = {
        method: "POST",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          invoiceNumber: payload.invoice_number,
          store: payload.store,
          products: payload.products,
          username: payload.username,
        }),
      };

      const res = await fetch(url, options);
      const data = await res.json();
      if (data.error) {
        rejectWithValue(res.error);
      }
      return data.result;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllReceipts = createAsyncThunk(
  "receipts/getAllReceipts",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const url = API_URL + "/classes/Receipt";
      const user = getState().user.userMe;
      const options = {
        method: "GET",
        headers: {
          "X-Parse-Application-Id": PARSE_APPLICATION_ID,
          "X-Parse-REST-API-Key": PARSE_REST_API_KEY,
          "X-Parse-Session-Token": user.sessionToken,
          "Content-Type": "application/json",
        },
      };

      const res = await fetch(url, options);
      const data = res.json();
      if (data.error) {
        rejectWithValue(res.error);
      }
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const getAllReceiptsQuery = createAsyncThunk(
  "receipts/getAllReceiptsQuery",
  async (payload, { getState, rejectWithValue }) => {
    try {
      const query = new Parse.Query("Receipt");
      query.limit(5000);
      const results = await query.find();
      
      return results;
      // const res = await fetch(url, options);
      // const data = res.json();
      // if (data.error) {
      //   rejectWithValue(res.error);
      // }
      // return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  validateReceiptsLoading: "IDLE",
  validateReceiptsError: null,
  getAllReceiptsLoading: "IDLE",
  getAllReceiptsError: null,
  allReceipts: null,
  manualReceiptAddLoading: "IDLE",
  manualReceptAddError: null,
  customerPointsGot: null,
  validateReceiptResult: null,
};

export const receiptsSlice = createSlice({
  name: "receipts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(validateReceipt.pending, (state, action) => {
      state.validateReceiptsLoading = "PENDING";
      state.validateReceiptsError = null;
    });
    builder.addCase(validateReceipt.fulfilled, (state, action) => {
      state.validateReceiptsLoading = "SUCCESS";
      state.validateReceiptsError = null;
      state.validateReceiptResult = action.payload.result;
    });
    builder.addCase(validateReceipt.rejected, (state, action) => {
      state.validateReceiptsLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.validateReceiptsError = err;
    });

    builder.addCase(manualReceiptAdd.pending, (state, action) => {
      state.manualReceiptAddLoading = "PENDING";
      state.manualReceptAddError = null;
    });
    builder.addCase(manualReceiptAdd.fulfilled, (state, action) => {
      state.manualReceiptAddLoading = "SUCCESS";
      state.manualReceptAddError = null;
      state.customerPointsGot = action.payload;
    });
    builder.addCase(manualReceiptAdd.rejected, (state, action) => {
      state.manualReceiptAddLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.manualReceptAddError = err;
    });

    builder.addCase(getAllReceipts.pending, (state, action) => {
      state.getAllReceiptsLoading = "PENDING";
      state.getAllReceiptsError = null;
    });
    builder.addCase(getAllReceipts.fulfilled, (state, action) => {
      state.getAllReceiptsLoading = "SUCCESS";
      state.validateReceiptsError = null;
      state.allReceipts = action.payload.results;
    });
    builder.addCase(getAllReceipts.rejected, (state, action) => {
      state.getAllReceiptsLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.validateReceiptsError = err;
    });

    builder.addCase(getAllReceiptsQuery.pending, (state, action) => {
      state.getAllReceiptsLoading = "PENDING";
      state.getAllReceiptsError = null;
    });
    builder.addCase(getAllReceiptsQuery.fulfilled, (state, action) => {
      state.getAllReceiptsLoading = "SUCCESS";
      state.validateReceiptsError = null;
      state.allReceipts = action.payload;
    });
    builder.addCase(getAllReceiptsQuery.rejected, (state, action) => {
      state.getAllReceiptsLoading = "FAILED";
      const err = {
        code: action.payload.code,
        message: action.payload.message,
      };
      state.validateReceiptsError = err;
    });
  },
});

// this is for dispatch
// export const {} = receiptsSlice.actions;

// this is for configureStore
export default receiptsSlice.reducer;
